const realme = {
  FORMS: [
    {
      type: 'realme-form-technical-service',
      name: 'RealmeTechnicalServiceForm',
      message: {
        open: 'Formulario Servicio Tecnico',
        send: 'Envío Formulario De Servicio Tecnico'
      }
    },
    {
      type: 'realme-form-product-executive',
      name: 'RealmeProductExecutiveForm',
      message: {
        open: 'Formulario de Comunicación con Experto de Productos',
        send: 'Envío Formulario de Comunicación con Experto de Productos'
      }
    }
  ],
  CSS: {
    id: '631904c9af1292be1c04b2ec',
    name: 'realme',
    avatar: {
      name: 'Realme',
      header: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/gHgr7mpU5TZm1662671020642.png',
      new: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/ijF324UTs2d31665065857455.gif',
      open: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/wndqimIvYOTH1662671181736.png',
      close: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/QD4enCo7PxjY1662671213502.png'
    },
    style: {
      score: {
        inactiveColor: '#ffffff',
        activeColor: '#FFC915',
        borderColor: '#FFC915'
      }
    }
  }
}

export default realme
